// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"IconSmallArrow_iconWrapper__2poXJ","arrowUp":"IconSmallArrow_arrowUp__4ZTyf","arrowDown":"IconSmallArrow_arrowDown__324uX"};